var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#DADADA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7604 10.1695C19.9387 9.9435 20.2953 9.9435 20.5181 10.1695L29.8329 19.6158C30.0557 19.8418 30.0557 20.1582 29.8329 20.3842L20.5181 29.8305C20.2953 30.0565 19.9387 30.0565 19.7604 29.8305L18.8691 28.9718C18.6462 28.7458 18.6462 28.3842 18.8691 28.2034L25.7772 21.1525H10.5348C10.2674 21.1525 10 20.9266 10 20.6102V19.3446C10 19.0734 10.2674 18.8023 10.5348 18.8023H25.7772L18.8691 11.7966C18.6462 11.6158 18.6462 11.2542 18.8691 11.0282L19.7604 10.1695Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledArrow);
export default __webpack_public_path__ + "static/media/DisabledArrow.ac2b465862022b5aeb417734f47fe2b0.svg";
export { ForwardRef as ReactComponent };